import React, {useState, useEffect} from 'react';
import CharterHead from "../../components/Dealers/CharterHead";
import {useHistory, useParams} from "react-router-dom";
import {requestApi} from "../../utils/utils";
import TripInfo from "../../components/Booking/SelectRoom/TripInfo";
import {Container, Grid} from "@mui/material";
import Typography from "@mui/material/Typography";
import CharterForm from "../../components/Dealers/CharterForm";

const CharterPage = () => {
    const [ship, setShip] = useState(null);
    const {shipCode} = useParams();
    const history = useHistory();

    useEffect(() => {
        getShipInfo().catch();
    }, []);

    const getShipInfo = async () => {
        const {data} = await requestApi(`/get-charter/${shipCode}`);
        if (data.status === 'success' && Object.keys(data.charter).length>0)
            return setShip({...data.location, ...data.charter});
        else
           return history.push('/');
    };

    return (
        <div>
            {ship && (<>
                <CharterHead ship={ship}/>
                <Container maxWidth="lg" className={'tripInfoDetails'}>
                    <Typography variant="h2" component="h2" className={'tripTitle'}>
                        {ship.location}
                    </Typography>
                    <Typography variant="body1" component="p" className={'tripDescription'}>
                        <span dangerouslySetInnerHTML={{__html: ship['description']}}/>
                    </Typography>
                    <TripInfo/>
                    <div style={{marginTop: 20}}/>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={12} md={12}>
                            <CharterForm ship={ship} />
                        </Grid>
                    </Grid>
                </Container>
            </>)}

        </div>
    );
};

export default CharterPage;